<p>update-secondary-phone works!</p>
